
import { DietFoodTypeId, DietFoodType } from 'app/dataTypes/org/dietFoodTypes'
import type { Request } from '../../index'




type DietFoodItemApi = {
  id: number
  title: string
}

type ApiResult = Array<DietFoodItemApi>

export const convertResult = (apiResult: ApiResult): Array<DietFoodType> => {
  return apiResult.map(item => ({
    id: item.id.toString() as DietFoodTypeId,
    title: item.title,
  }))
}

export const GET_DIET_FOOD_TYPES: Request<void, Array<DietFoodType>, void> = [
  'food/diet_food_types',
  'get',
  ['data', 'diet_food_types'],
]
